<template>
  <div>
    <b-row class="p-2 text-light bg-dark">
      <b-col><strong>FN</strong></b-col>
      <b-col><strong>Type</strong></b-col>
      <b-col><strong>Weight class</strong></b-col>
      <b-col><strong>Red Corner</strong></b-col>
      <b-col><strong>Blue Corner</strong></b-col>
    </b-row>
    <draggable v-model="matches" group="people" @start="drag=true" @end="drag=false">
      <b-row
        v-for="(m, index) in matches"
        :key="m.id"
        class="p-2 border"
        :class="{ 'table-secondary' : m.type === 'Matchfight' }"
      >
        <b-col>{{index}}</b-col>
        <b-col>{{m.type}}</b-col>
        <b-col>{{m.weightClass}}</b-col>
        <b-col>{{m.redCorner}}</b-col>
        <b-col>{{m.blueCorner}}</b-col>
      </b-row>
    </draggable>

    <div class="text-right m-2">
      <b-button variant="primary">Save</b-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'Schedule',
  components: { draggable },
  props: ['matches'],
};
</script>

<style scoped>

</style>
